<template>
  <nav class="vlogs-filter">
    <section class="vlogs-filter__section">
      <p class="vlogs-filter__subheading">
        {{ $t('common.vlogs.season') }}
      </p>
      <FormBaseCheckbox
        v-for="season in availableSeasons"
        :key="season"
        v-model="filters.selectedSeasons[season]"
        :label="`${season} ${$t('common.vlogs.season')}`"
        small
      />
    </section>
  </nav>
</template>

<script lang="ts" setup>
const vlogsStore = useVlogsStore()

const { filters, availableSeasons } = storeToRefs(vlogsStore)
</script>

<style lang="scss" scoped>
.vlogs-filter {
  position: sticky;
  top: 120px;

  &__subheading {
    @include heading-subheading;

    margin-bottom: 12px;
  }

  &__divider {
    width: 100%;
    height: 1px;
    background-color: var(--navy-100);
    margin-bottom: 20px;
  }
}
</style>
